
import { EntityMeta } from "@backstage/catalog-model";
import { useApi, configApiRef } from '@backstage/core-plugin-api';

export type DevopsMetadataLinks = {
  organization: string;
  repository: string;
  pipelines: string;
  pipelinesAutomatedTests: string;
};

export function useDevopsMetaLinks(metadata: EntityMeta): DevopsMetadataLinks {

  const { annotations } = metadata;

  const links = useBuildDevopsLinks();

  if (!annotations) {
    return links;
  }

  buildRepositoryLink(links, annotations);
  buildPipelinesLink(links, annotations);
  buildPipelinesAutomatedTestsLink(links, annotations);
  
  return links;
}

function useBuildDevopsLinks(): DevopsMetadataLinks {
  const organization = useDevopsOrganizationLink();
  return {
    organization,
    repository: '',
    pipelines: '',
    pipelinesAutomatedTests: ''
  }
}

function useDevopsOrganizationLink(): string {

  const config = useApi(configApiRef);

  const host = config.getOptionalString('azureDevOps.host') || 'dev.azure.com';
  const organization = config.getOptionalString('azureDevOps.organization') || 'totvstfs';

  return `https://${host}/${organization}`;
}

function buildRepositoryLink(links: DevopsMetadataLinks, annotations: Record<string, string>) {
  const values = parseAnnotationValue(annotations['dev.azure.com/project-repo']);
  if (values) {
    links.repository = `${links.organization}/${values.project}/_git/${values.target}`;
  }
}

function buildPipelinesLink(links: DevopsMetadataLinks, annotations: Record<string, string>) {
  const values = parseAnnotationValue(annotations['dev.azure.com/pipelines']);
  if (values) {
    links.pipelines = `${links.organization}/${values.project}/_build?${values.target}`;
  }
}

function buildPipelinesAutomatedTestsLink(links: DevopsMetadataLinks, annotations: Record<string, string>) {
  const values = parseAnnotationValue(annotations['dev.azure.com/pipelines-automated-tests']);
  if (values) {
    links.pipelinesAutomatedTests = `${links.organization}/${values.project}/_build?${values.target}`;
  }
}

interface AnnotationValues {
  project: string,
  target: string
}

function parseAnnotationValue(annotation: string): AnnotationValues | undefined {

  if (!annotation) {
    return undefined;
  }

  const [project, ...rest] = annotation.split('/')
  const target = rest.join('/')

  return { project, target };
}

